import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '~/redux/store'

export interface Linje5SliceType {
  monthlyDiscount: { discount: number; duration: number }
  yearlyDiscount: { discount: number }
}

const initialState: Linje5SliceType = {
  monthlyDiscount: { discount: 0, duration: 0 },
  yearlyDiscount: { discount: 0 },
}

const slice = createSlice({
  name: 'linje5-slice',
  initialState,
  reducers: {
    setMonthlyDiscount: (state, action: PayloadAction<Linje5SliceType['monthlyDiscount']>) => {
      state.monthlyDiscount = action.payload
    },
    setYearlyDiscount: (state, action: PayloadAction<Linje5SliceType['yearlyDiscount']>) => {
      state.yearlyDiscount = action.payload
    },
  },
})

export const selectMonthlyDiscount = (state: RootState): Linje5SliceType['monthlyDiscount'] =>
  state.linje5.monthlyDiscount

export const selectYearlyDiscount = (state: RootState): Linje5SliceType['yearlyDiscount'] => state.linje5.yearlyDiscount

export const {
  setMonthlyDiscount: setMonthlyDiscountActionCreator,
  setYearlyDiscount: setYearlyDiscountActionCreator,
} = slice.actions

export default slice.reducer
